<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page">
          <v-flex class="cont-img animated fadeInUp dura-2" md7 sm7 xs11>
              <v-card color="transparent" flat tile>
                  <v-window v-model="onboarding">
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat>
                        <h2 class="titulo-descripcion">Lugar  {{n}} / 5</h2>
                        <img class="cont-img" :src="require('@/assets/unidad1/slide-18/slide-18-'+(onboarding+1)+'.jpg')" alt="">
                        <h2 class="titulo-descripcion">Descrição</h2>
                        <p v-html="lugares[onboarding]"></p>
                        <p v-html="textos[onboarding]"></p>
                      </v-card>
                    </v-window-item>
                  </v-window>
              </v-card>
          </v-flex>
          <v-flex class="cont-img animated fadeInUp dura-2" md7 sm7 xs12>
            <button class="btn-caso hvr" @click="respAction('n')"><span>N.A</span></button>
            <button class="btn-caso hvr" @click="respAction('o')"><span>O/OS</span></button>
            <button class="btn-caso hvr" @click="respAction('a')"><span>A/AS</span></button>
          </v-flex>
        </v-layout>
        <!-- modal Resultado -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()">
        </modal-resultado-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      currentText: 0,
      dialogos: [
        'Diga onde usamos ou não artigo definido. Clique na resposta.'
      ],
      textos:[
        'É uma ilha.',
        'Apelido: Cidade Luz.',
        'Liga um lugar a outro.',
        'Está localizada entre Israel e o Líbano.',
        'Bairros tradicionais têm muitas casas.'
      ],
      lugares:[
        'CUBA', 'PARIS', 'PONTE', 'PALESTINA','BAIRRO'
      ],
      length: 5,
      onboarding: 0,
      respuestaCorrecta:'n',
      modalresultado:false,
      modalResult:'bien'
    }
  },
  methods: {
    respAction(val){
      console.log(val)
      console.log(this.respuestaCorrecta)
      if(val == this.respuestaCorrecta){
        this.modalresultado = true
        this.modalResult = 'bien'
      }else{
        this.modalresultado = true
        this.modalResult = 'mal'
      }
    },
    bienAction(){
      if(this.onboarding == 4){
        this.$store.commit('nextShow', true);
      }else{
        this.onboarding = this.onboarding + 1
      }
    }
  },
  watch: {
    onboarding(val){
      switch (val) {
        case 0:
        case 1:
          this.respuestaCorrecta = 'n'
          break;       
        case 2:
        case 3:
          this.respuestaCorrecta = 'a'
          break;
        case 4:
          this.respuestaCorrecta = 'o'
          break;
        default:
          this.respuestaCorrecta = ''
          break;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont_text-slider{
  height: auto;
  img{
    height: 150px;
  }
  p{
    font-family: Poppins-Regular;
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 20px;
    height: 20px;
  }
}
.cont-letras{
  .letra-button{
    border: solid $ibra-dark-blue;
    width: 53px;
    height: 53px;
    margin: 8px;
    border-radius: 10px;
    .t-blue{
      color: $ibra-dark-blue;
      font-family:Poppins-Regular;
      font-size: 35px;
      margin: 0;
      padding: 0;
      line-height: 0;
    }
  }
}
.titulo-descripcion{
  font-family: Poppins-Bold;
  font-size: 15px;
}
.cont-img{
  margin: 10px 0px;
}
.btn-caso{
  width: 65px;
  height: 65px;
  background: #666666;
  border-radius: 50%;
  margin: 0 3px;
  span{
    font-family: Poppins-Bold;
    font-size: 16px;
    color:white;
  }
}
</style>
